export const prizeType = [
  { label: "En efectivo", value: "CASH" },
  { label: "En especie", value: "KIND" }
];
